export const ACCESS_TOKEN = 'access-token';
export const REFRESH_TOKEN = 'refresh-token';
export const PERSONAL_INFO = 'personal-info';
